export default __webpack_public_path__ + "static/media/girl-eating@3x.ca7499e8.png";